export enum ListReviewAndPublishMode {
  REVIEW_AND_PUBLISH = 'review_and_publish',
  PUBLISH_WITH_REVIEW_REMINDER = 'publish_with_review_reminder',
  FORCE_REVIEW = 'force_review',
  REVIEW_ONLY = 'review_only',
}

export const LIST_REVIEW_AND_PUBLISH_WORKFLOWS: ListReviewAndPublishMode[] = Object.keys(
  ListReviewAndPublishMode,
).map(key => ListReviewAndPublishMode[key]);
